import React from 'react'
import moment from 'moment'
import PlanEntryOptions from './PlanEntryOptions'
import Favoritable from '../favoriteButton/Favoritable'
import PlusIcon from '../favoriteButton/PlusIcon'
import HelpPopup from '../helpPopup/HelpPopup'
import PropTypes from 'prop-types'
import LockIcon from '../../../assets/codicons/lock'
import './PlanEntryListRow.scss'

class PlanEntryListRow extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      fadeOut: false
    }

    this.fadeRowOut = this.fadeRowOut.bind(this)
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this)

    this.planEntryClassName = 'PlanEntryListRow'
  }

  fadeRowOut() {
    this.setState({ fadeOut: true })
  }

  handleTransitionEnd(e) {
    e.stopPropagation()

    if (
      e.currentTarget === e.target &&
      this.state.fadeOut &&
      e.propertyName === 'opacity'
    ) {
      if (this.toggleFavorite) {
        this.toggleFavorite()
        this.toggleFavorite = null
      }
      this.props.onDeleted()
    }
  }

  formatDateAddedLabel(dateAdded) {
    const createdAt = moment(dateAdded)
    const now = moment()

    if (now.diff(createdAt, 'days') > 14) {
      return createdAt.format('MMM D, YYYY')
    } else {
      return createdAt.fromNow()
    }
  }

  render() {
    const {
      planEntry,
      dateAdded,
      favoritable,
      featurable,
      sortable,
      locked,
      includeDates,
      entryId
    } = this.props

    const plan = planEntry.planProduct

    let handle
    if (sortable) {
      handle = <i className='i fa fa-bars' />
    }

    let favoriteButton
    if (favoritable) {
      favoriteButton = (
        <span className='PlanEntryListRow__favoriteButton'>
          <Favoritable planEntry={planEntry}>
            {({ toggleFavorite, isFavorited }) => (
              <HelpPopup
                trigger={
                  <PlusIcon
                    active={isFavorited}
                    onClick={() => {
                      this.toggleFavorite = toggleFavorite
                      this.fadeRowOut()
                    }}
                  />
                }
                width={211}
                topOffset={-10}
                leftOffset={10}
              >
                {isFavorited ? 'Remove from' : 'Add to'} my practice
              </HelpPopup>
            )}
          </Favoritable>
        </span>
      )
    }

    let dateAddedLabel
    if (includeDates) {
      dateAddedLabel = (
        <span className='PlanEntryListRow__date'>
          {this.formatDateAddedLabel(dateAdded)}
        </span>
      )
    }

    let className = this.planEntryClassName
    if (this.state.fadeOut) className += ' PlanEntryListRow--faded'

    return (
      <div
        className={className}
        onTransitionEnd={this.handleTransitionEnd}
        data-id={entryId}
      >
        <a
          href={`${planEntry.buildEntryUrl()}${
            this.props.entryLinkSuffix || ''
          }`}
        >
          <span className='PlanEntryListRow__dragHandle'>{handle}</span>
          {favoriteButton}
          <span
            className={`PlanEntryListRow__completedIcon ${
              planEntry.completed
                ? 'PlanEntryListRow__completedIcon--completed'
                : ''
            }`}
          />
          <span
            className={`PlanEntryListRow__image ${
              locked ? 'PlanEntryListRow__image--locked' : ''
            }`}
          >
            {locked ? <LockIcon /> : null}
            <img src={planEntry.videoThumbnail} />
          </span>
          <span className='PlanEntryListRow__title'>{planEntry.title}</span>
          <span className='PlanEntryListRow__plan'>
            <a href={plan.url()}>{plan.title}</a>
          </span>
          <span className='PlanEntryListRow__coach'>
            {planEntry?.plan?.coaches.map((coach, idx) => {
              let coachName = `${coach.firstName} ${coach.lastName}`
              const length = planEntry?.plan?.coaches?.length
              if (length > 1 && idx === length - 1) {
                coachName = ' & '.concat(coachName)
              }
              if (length > 0 && idx < length - 2) {
                coachName += ', '
              }
              if (coach.coachInfo) {
                return (
                  <a
                    key={coach.coachInfo.slug}
                    href={'/instructors/' + coach.coachInfo.slug}
                    data-refmarks-element='true'
                  >
                    {coachName}
                  </a>
                )
              } else {
                return <span key={idx}>{coachName}</span>
              }
            })}
          </span>
          <span className='PlanEntryListRow__duration'>
            {planEntry.humanDuration}
          </span>

          {dateAddedLabel}

          <span
            className='PlanEntryListRow__options'
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}
          >
            <PlanEntryOptions
              planEntry={planEntry}
              featurable={featurable}
              onDelete={this.fadeRowOut}
              removable={this.props.removable}
            />
          </span>
        </a>
      </div>
    )
  }
}

PlanEntryListRow.propTypes = {
  planEntry: PropTypes.object,
  rowItemStyles: PropTypes.object,
  featurable: PropTypes.bool,
  favoritable: PropTypes.bool,
  locked: PropTypes.bool,
  includeDates: PropTypes.bool,
  sortable: PropTypes.bool,
  onDeleted: PropTypes.func,
  entryId: PropTypes.number,
  removable: PropTypes.bool,
  dateAdded: PropTypes.string,
  entryLinkSuffix: PropTypes.string
}

export default PlanEntryListRow
